import React from 'react';
import MuiCircularProgress, { CircularProgressProps as MuiCircularProgressProps } from '@mui/material/CircularProgress';

/**
 * Pioneer CircularProgress — wraps MUI CircularProgress with project defaults.
 *
 * Defaults:
 * - size={24} (Pioneer standard inline spinner size)
 *
 * All MUI CircularProgress props are supported and can override defaults.
 */
export interface CircularProgressProps extends MuiCircularProgressProps {}

const CircularProgress = React.forwardRef<React.ComponentRef<typeof MuiCircularProgress>, CircularProgressProps>(
  function CircularProgress(props, ref) {
    return <MuiCircularProgress size={24} ref={ref} {...props} />;
  },
);

export default CircularProgress;
